module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_document_x32-f7c74.png";